// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper_MoqLd","button":"index_button_HWKAr"};